import { useLocation, Outlet } from "react-router-dom";
import {
  Users, Network, BarChart3, Building2, Shield, Trophy, FileText, Umbrella
} from "lucide-react";
import HubSidebar from "@/components/HubSidebar";


import TopNav from "@/components/TopNav"
import HubSwitcher from "@/components/HubSwitcher";
const NAV_ITEMS = [
  {
    id: "human-centre",
    label: "Human Centre",
    icon: Network,
    path: "/hr-hub/human-centre",
    description: "Profiles & Reports"
  },
  {
    id: "our-organisation",
    label: "Our Organisation",
    icon: Building2,
    path: "/hr-hub/our-organisation",
    description: "Organogram & Structure"
  },
  {
    id: "hr-admin",
    label: "HR Admin",
    icon: Shield,
    path: "/hr-hub/hr-admin",
    description: "Manage HR Settings"
  },
  {
    id: "hr-intelligence",
    label: "HR Intelligence",
    icon: BarChart3,
    path: "/hr-hub/hr-intelligence",
    description: "AI Workforce Analytics"
  },
  {
    id: "performance",
    label: "Performance App",
    icon: Trophy,
    path: "/hr-hub/performance",
    description: "KPA Assessment & Reviews"
  },
  {
    id: "smart-management",
    label: "Smart Management",
    icon: FileText,
    path: "/hr-hub/smart-management",
    description: "Document Lifecycle Management"
  },
  {
    id: "leave-management",
    label: "Leave Management",
    icon: Umbrella,
    path: "/hr-hub/leave-management",
    description: "Leave Requests & Approvals"
  }
];

export default function HRHubLayout() {
  const location = useLocation();
  const currentPath = location.pathname;

  return (
    <>
    <TopNav />
    <div className="min-h-screen bg-app flex flex-col md:flex-row">
      <HubSidebar
        navItems={NAV_ITEMS}
        title="HR HUB"
        subtitle="Human Resources Management"
        icon={Users}
        gradient="from-emerald-500 to-teal-600"
        activeBg="bg-emerald-500"
      />

      <main className="flex-1 overflow-auto flex">
        <div className="flex-1 min-w-0 p-4">
          <Outlet />
        </div>
        <div className="hidden lg:block w-40 shrink-0 p-3 border-l border-app">
          <HubSwitcher />
        </div>
      </main>
    </div>
    </>
  );
}
